import {HttpEvent, HttpHandler, HttpInterceptor, HttpRequest} from "@angular/common/http";
import {Injectable} from "@angular/core";
import {Observable} from "rxjs/Observable";

@Injectable()
export class IndicatorTemplateInterceptor implements HttpInterceptor {
  intercept(req: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
    const isFromIndicatorEditScreen: boolean = window.location.href.indexOf("/Indicator/IndicatorEdit/2364") > -1;
    const isIndicatorTemplateScreen: boolean = window.location.href.indexOf("is-template=true") > -1;

    if ((isIndicatorTemplateScreen && this.isIndicatorTemplateCreateUpdateRequest(req)) || (isFromIndicatorEditScreen && this.isIndicatorSaveAsTemplateRequest(req))) {
      const body = JSON.parse(JSON.stringify(JSON.parse(req.body)));
      body.entity.Code = null;
      body.entity.IndicatorPriorityIDs = [];

      // PRIME-13223
      body.entity.ReasonForRejection = null;

      // for Save as Template action
      body.entity.isTemplate = 1;

      // remove after ME implementation (ME resets only on Clone action)
      body.entity.lastActionId = null;
      req = req.clone({
        body
      });
    }

    return next.handle(req).catch((error, caught) => {
      console.log('Error Occurred');
      console.log(error);
      return Observable.throw(error);
    }) as any;
  }

  private isIndicatorSaveAsTemplateRequest(req: HttpRequest<any>) {
    const isPost: boolean = req.method.toLowerCase() === "post";
    const regex = /.*prime\/entity\/IndicatorTemplate?/;
    return isPost && regex.test(req.url);
  }

  private isIndicatorTemplateCreateUpdateRequest(req: HttpRequest<any>) {
    const isPost: boolean = req.method.toLowerCase() === "post";
    const isPut: boolean = req.method.toLowerCase() === "put";
    const regex = /.*prime\/entity\/IndicatorTemplate/;
    return (isPost || isPut) && regex.test(req.url);
  }
}

